// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".join-channel-dialog.common-dialog[data-v-564d5866] .el-dialog{width:var(--common-dialog-medium-width)}.join-channel-dialog.common-dialog .el-form[data-v-564d5866]{margin-right:var(--common-dialog-form-margin-right)}.join-channel-dialog.common-dialog .el-select[data-v-564d5866]{width:100%}", ""]);
// Exports
module.exports = exports;
